import { getFormattedLinkToBrowser } from '~/utils/url';

export const GENERAL_CONDITIONS_LINK = getFormattedLinkToBrowser(
  'https://psffiles.blob.core.windows.net/psfcontratos/termos/seguros/redemais/marisa-cuida/condicoes-gerais-contratacao.pdf'
);
